<template>
  <div class="bg-home-banner-bg-2-mobile bg-cover md:bg-home-banner-bg-2-desktop">
    <div
      class="flex flex-col justify-self-center w-[90%] max-w-[1200px] md:mx-auto md:flex-row items-center mx-5 py-10 md:py-20 ">
      <div class="w-full md:w-1/2 my-3 md:my-0 text-center md:text-start">
        <h2 class="text-ROJO_LEON mx-auto md:ml-0 flex flex-col font-bold text-[27px] md:text-2xl">
          <span class="flex flex-row items-center justify-center md:justify-start">CON
            <img class="h-5 md:h-5 px-1 mb-1.5" :src="'/img/shared/leon-logo-text.webp'" alt="leon-logo-text" />
          </span>
          <span>OBTIENES MÁS QUE LUBRICANTES</span>
        </h2>

        <p class="md:max-w-[500px] my-3 text-left text-[20px]">
          Somos distribuidores oficiales de las mejores marcas de neumáticos y
          contamos con stock permanente.
        </p>

        <p class="font-bold my-3 text-[27px]">Las mejores marcas del mundo</p>
        <button type="button" @click="abrir_modal_agenda" class="hidden md:block bg-ROJO_LEON text-white rounded-md font-bold py-2 my-10
                hover:bg-GRIS_CLARO_COMPLEMENTARIO_2 hover:text-ROJO_LEON
                w-1/2 transition mx-auto md:mx-0 text-center">
          Agenda tu cita ahora
        </button>
      </div>

      <!-- DESKTOP -->
      <div class="hidden md:flex flex-col items-center my-6 gap-[20px]">

        <!-- Fila 1: 3 logos -->
        <div class="flex gap-[20px]">
          <div v-for="(brand, index) in brands.slice(0, 3)" :key="'top-' + index" class="w-[210px] h-[90px] bg-white rounded-md flex items-center justify-center
                        hover:scale-105 transition-transform p-6 shadow-lg">
            <img class="max-h-full max-w-full object-contain" :src="brand.src" :alt="brand.alt" />
          </div>
        </div>

        <!-- Fila 2: 2 logos centrados -->
        <div class="flex gap-[20px]">
          <div v-for="(brand, index) in brands.slice(3, 5)" :key="'bottom-' + index" class="w-[210px] h-[90px] bg-white rounded-md flex items-center justify-center
                        hover:scale-105 transition-transform p-6 shadow-lg">
            <img class="max-h-full max-w-full object-contain" :src="brand.src" :alt="brand.alt" />
          </div>
        </div>

      </div>


      <!-- MOBILE: grilla estática -->
      <div class="md:hidden flex flex-col items-center gap-3 mb-4">

        <!-- Fila 1 -->
        <div class="flex gap-4">
          <div v-for="(brand, index) in brands.slice(0, 2)" :key="'row1-' + index"
            class="w-[180px] h-[90px] bg-white rounded-md flex items-center justify-center p-4 shadow-lg">
            <img class="max-w-full max-h-full object-contain" :src="brand.src" :alt="brand.alt" />
          </div>
        </div>

        <!-- Fila 2 -->
        <div class="flex gap-4">
          <div v-for="(brand, index) in brands.slice(2, 4)" :key="'row2-' + index"
            class="w-[180px] h-[90px] bg-white rounded-md flex items-center justify-center p-4 shadow-lg">
            <img class="max-w-full max-h-full object-contain" :src="brand.src" :alt="brand.alt" />
          </div>
        </div>

        <!-- Fila 3 (centrado) -->
        <div class="flex justify-center">
          <div class="w-[180px] h-[90px] bg-white rounded-md flex items-center justify-center p-4 shadow-lg">
            <img class="max-w-full max-h-full object-contain" :src="brands[4].src" :alt="brands[4].alt" />
          </div>
        </div>
      </div>
      <button type="button" @click="abrir_modal_agenda" class="md:hidden bg-ROJO_LEON text-white rounded-md font-bold py-2 mt-2
              hover:bg-GRIS_CLARO_COMPLEMENTARIO_2 hover:text-ROJO_LEON
              w-1/2 transition mx-auto text-center">
        Agenda tu cita ahora
      </button>

    </div>
  </div>

  <ModalAgendaAceites v-if="mostrar_modal_agenda" @close="cerrar_modal_agenda" />

</template>

<script setup>
import ModalAgendaAceites from '~/components/Modals/ModalAgendaAceites.vue'

const swiperInit = ref(false);

const mostrar_modal_agenda = ref(false)

const abrir_modal_agenda = () => {
  mostrar_modal_agenda.value = true
}

const cerrar_modal_agenda = () => {
  mostrar_modal_agenda.value = false
}

const scrollToTop = () => {
  window.scrollTo({
    top: 140,
    behavior: "smooth",
  });
  const input = document.querySelector("#first-input");
  if (input) {
    input.focus();
  }
};

const brands = [
  {
    src: '/img/aceites/marcas/total.svg',
    alt: 'logo-total'
  },
  {
    src: '/img/aceites/marcas/champion.svg',
    alt: 'logo_champion'
  },
  {
    src: '/img/aceites/marcas/mobil.svg',
    alt: 'logo_mobil'
  },
  {
    src: '/img/aceites/marcas/shell.svg',
    alt: 'logo_shell'
  },
  {
    src: '/img/aceites/marcas/castrol.svg',
    alt: 'logo_castrol'
  }
];

onMounted(() => {
  swiperInit.value = true;
});
</script>